import ColorRound from './ColorRound.vue'

export default ColorRound
